
import { Vue } from "vue-class-component";

export default class ClockV3 extends Vue {}
